export enum CellType {
	Standard,
	Date,
	DateAndTime,
	List,
	Enum,
	Workflow,
	Color,
}
